import React from 'react';
import PropTypes from 'prop-types';
import { Loading as SaaghiLoading } from '@takhfifan/saaghi';

const Loading = (props) => {
	return <SaaghiLoading {...props} />;
};

Loading.propTypes = {
	color: PropTypes.string,
	size: PropTypes.string, //sm, md, lg, xl
	status: PropTypes.string, //loading, success, error, warning
	className: PropTypes.string,
};

export default Loading;
